"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
var type_rest_1 = require("type-rest");
var apiRoot = process.env.API_ROOT ? process.env.API_ROOT : process.env.VUE_APP_API_ROOT;
exports.Api = type_rest_1.typeRest(apiRoot, {
    params: {
        mode: "cors",
    },
    hooks: [
        {
            type: "post",
            path: "/auth/",
            method: "POST",
            hook: function (ev) {
                if (typeof ev.response === "object" && "token" in ev.response && typeof ev.response["token"] === "string")
                    ev.instance._options.params.headers.token = ev.response["token"];
            },
        },
        {
            type: "post",
            path: "/auth/",
            method: "DELETE",
            hook: function (ev) {
                if (typeof ev.response === "object" && "valid" in ev.response && ev.response["valid"] === true) {
                    ev.instance._options.params.headers.token = undefined;
                    delete ev.instance._options.params.headers.token;
                }
            },
        },
    ],
});
//# sourceMappingURL=index.js.map